export default "__VITE_ASSET__C0G$4EKA__"